import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"

import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Table,
  CardTitle,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getQuotes as onGetOrders,
  addNewQuote as onAddNewOrder,
  updateQuote as onUpdateOrder,
  deleteQuote as onDeleteOrder,
  getAuthUsers as onGetAuthUser,
} from "store/actions"

import QuotesOrdersModal from "./QuotesOrdersModal"
import Columns from "./Columns"
import { expandRow } from "./orderDetails"
import OffCanvasModel from "components/OrdersOffCanvas/offCanvas"
import SweetAlert from "react-bootstrap-sweetalert"

const QuotesOrders = props => {
  const dispatch = useDispatch()

  const [orderList, setOrderList] = useState([])
  const [order, setOrder] = useState(null)

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: (order && order.orderId) || "",
      billingName: (order && order.billingName) || "",
      orderdate: (order && order.orderdate) || "",
      total: (order && order.total) || "",
      paymentStatus: (order && order.paymentStatus) || "Paid",
      badgeclass: (order && order.badgeclass) || "success",
      paymentMethod: (order && order.paymentMethod) || "Mastercard",
    },
    validationSchema: Yup.object({
      orderId: Yup.string().required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderdate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string().required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeclass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateOrder = {
          id: order ? order.id : 0,
          orderId: values.orderId,
          billingName: values.billingName,
          orderdate: values.orderdate,
          total: values.total,
          paymentStatus: values.paymentStatus,
          paymentMethod: values.paymentMethod,
          badgeclass: values.badgeclass,
        }
        // update order
        dispatch(onUpdateOrder(updateOrder))
        validation.resetForm()
      } else {
        const newOrder = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          orderId: values["orderId"],
          billingName: values["billingName"],
          orderdate: values["orderdate"],
          total: values["total"],
          paymentStatus: values["paymentStatus"],
          paymentMethod: values["paymentMethod"],
          badgeclass: values["badgeclass"],
        }
        // save new order
        dispatch(onAddNewOrder(newOrder))
        validation.resetForm()
      }
      toggle()
    },
  })

  const { orders, designerUsers } = useSelector(state => ({
    orders: state.Quotes.quotes,
    designerUsers: state.Quotes.auth
  }))

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [designers, setDesigners] = useState({})
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: 50,
    custom: true,
  })
  
  const handleTableChange = (type, { page, sizePerPage }) => {
    let json = {params: {requestFor:"quote"}, paginate:{ size: 50, page: page }}
    // dispatch(onGetOrders(json))
  }


  //pagination customization
  // const pageOptions = 

  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setModal1(!modal1)
  // }

  const toggleViewModal = () => setModal1(!modal1)

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }

  useEffect(() => {
    if (!orders.hasOwnProperty("docs")) {
      let json = {params: {requestFor:"quote"}, paginate:{ size: 50, page: 1 }}
      // dispatch(onGetOrders(json))
    }
  }, [dispatch, orders])

  useEffect(() => {
    if (!designerUsers.hasOwnProperty("docs")) {
      dispatch(onGetAuthUser())
    }
    setDesigners(designerUsers);
  }, [dispatch, designerUsers])
  

  useEffect(() => {
    setOrderList(orders)
    setPageOptions({
      sizePerPage: orders.limit,
      page: orders.offset,
      totalSize: orders.totalDocs,
      custom: true,
    })
  }, [orders])

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders)
      setIsEdit(false)
    }
  }, [orders])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  const handleOrderClick = arg => {
    const order = arg

    setOrder({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderdate: order.orderdate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeclass: order.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = order => {
     // setOrder(order)
    // setDeleteModal(true)
    dispatch(onDeleteOrder(order._id))
  }


  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const handleChange = (oldValue, newValue, row, column, done) => {
    if(column.dataField === "assTo"){
      dispatch(onUpdateOrder(row));
    }else{
      dispatch(onUpdateOrder(row));
    }
  }

   const handleConfirm = (id) => {
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => { }}
        onCancel={() => { }}
        focusCancelBtn
      >
        You will not be able to recover this record!
      </SweetAlert>
      // );
    };

  return (
    <React.Fragment>
      <OffCanvasModel isRight={isRight} toggleRightCanvas={toggleRightCanvas} />
      <QuotesOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        <MetaTags>
          <title>Quotes</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Quotes" breadcrumbItem="Quotes" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleOrderClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      handleConfirm.
                      designers
                    )}
                    data={orders.hasOwnProperty("docs") ? orders.docs : orders}
                    // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          orders.hasOwnProperty("docs") ? orders.docs : orders
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleOrderClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          handleConfirm,
                          designers
                        )}
                        bootstrap4
                        search
                        // cellEdit={ cellEditFactory({ mode: 'click' }) }
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              {/* <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded  mb-2 me-2"
                                    // onClick={handleOrderClicks}
                                    onClick={toggleRightCanvas}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add New Order
                                  </Button>
                                </div>
                              </Col> */}
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={ {
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false
                                    } }
                                    keyField="_id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={"table align-middle table-nowrap table-check"}
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={ handleTableChange  }
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange
                                    })}
                                    expandRow={expandRow}
                                    ref={node}
                                  />
                                </div>
                               
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

QuotesOrders.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onAddNewOrder: PropTypes.func,
  onDeleteOrder: PropTypes.func,
  onUpdateOrder: PropTypes.func,
}

export default withRouter(QuotesOrders)
